"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Flex = _interopRequireDefault(require("../Components/Flex"));
var _String = _interopRequireDefault(require("../Components/String"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * A section in a question set - e.g. item/person etc.
 * 
 * @package HOPS
 * @subpackage OrderQuestions
 * @copyright Operations Processing Limited
 */const OrderQuestionSection = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
    mt: props.mt,
    children: [!props.noLabel && /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
      color: "textSecondary",
      str: props.label
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
      pl: 1,
      children: props.children
    })]
  });
};
OrderQuestionSection.propTypes = {
  children: _propTypes.default.node,
  label: _propTypes.default.string,
  mt: _propTypes.default.number,
  noLabel: _propTypes.default.bool
};
OrderQuestionSection.defaultProps = {
  mt: 0,
  noLabel: false
};
var _default = exports.default = OrderQuestionSection;